<template>
  <div>
    <div class="row">
      <ul v-if="challengeData.tasks.length > 1" class="nav nav-tabs stage-tabs">
        <li
            v-for="(stage, index) in challengeData.tasks"
            data-toggle="tab"
            :class="{'active': stage.task_id === currentTaskId || stage.task_id === taskId}">
          <a href="#" @click.prevent="setTaskIdWithIndex(index)">Stage {{ (index + 1) }}</a>
        </li>
      </ul>
    </div>
    <div class="row">
      <ul class="nav nav-tabs stage-tabs">
        <li :class="{active: otherSolutionView === 'new' && isNotBlockedTaskId, 'disabled': !isNotBlockedTaskId}"><a class="flex" href="#"
                                                              @click.prevent="setOtherSolutionView('new')"><i
            class="icon dev-time"></i><span>brandneu</span></a></li>
        <li :class="{active: otherSolutionView === 'bestRated' && isNotBlockedTaskId, 'disabled': !isNotBlockedTaskId}"><a class="flex" href="#"
                                                                    @click.prevent="setOtherSolutionView('bestRated')"><i
            class="icon dev-star"></i><span>best bewertet</span></a></li>
        <li :class="{active: otherSolutionView === 'mostComments' && isNotBlockedTaskId, 'disabled': !isNotBlockedTaskId}"><a class="flex" href="#"
                                                                       @click.prevent="setOtherSolutionView('mostComments')"><i
            class="icon dev-chat-dots"></i><span>oft kommentiert</span></a></li>
        <li :class="{active: otherSolutionView === 'ratedByMe' && isNotBlockedTaskId, 'disabled': !isNotBlockedTaskId}"><a class="flex" href="#"
                                                                    @click.prevent="setOtherSolutionView('ratedByMe')"><i
            class="icon dev-user-heart"></i><span>von mir bewertet</span></a></li>
      </ul>
    </div>
    <div v-if="!isNotBlockedTaskId" class="row">
      <p style="margin: 1rem 2rem;">
        Diese {{ notBlockedTaskIds.length === 0 ? 'Challenge' : 'Stage' }} ist leider <strong>nicht für Rank the Code verfügbar.</strong>
      </p>
    </div>
    <div v-if="isNotBlockedTaskId" class="row">
      <div v-if="otherSolutionView==='new'">
        <other-solutions-list
            :challenge-data="challengeData"
            :task-id="currentTaskId"
            :view="otherSolutionView">
        </other-solutions-list>
      </div>
      <div v-if="otherSolutionView==='bestRated'">
        <other-solutions-list v-if="currentTaskId"
            :challenge-data="challengeData"
            :task-id="currentTaskId"
            :view="otherSolutionView">
        </other-solutions-list>
      </div>
      <div v-if="otherSolutionView==='mostComments'">
        <other-solutions-list  v-if="currentTaskId"
            :challenge-data="challengeData"
            :task-id="currentTaskId"
            :view="otherSolutionView">
        </other-solutions-list>
      </div>
      <div v-if="otherSolutionView==='ratedByMe'">
        <other-solutions-list v-if="currentTaskId"
            :challenge-data="challengeData"
            :task-id="currentTaskId"
            :view="otherSolutionView">
        </other-solutions-list>
      </div>
    </div>
  </div>

</template>

<script>
  import {services} from "../../main";
  import {mapState} from "vuex";
  import {LANGUAGES} from "../../const";
  import OtherSolutionsList from "./OtherSolutionsList";
  import OtherSolutionModal from "./OtherSolutionModal";
  import StarRating from "../StarRating";

  export default {
    name: "OtherSolutionsTabComponent",
    components: {StarRating, OtherSolutionsList, OtherSolutionModal},
    props: {
      challengeData: {
        type: [Object],
        default() {
          return {}
        }
      },
      taskId: {type: String, default: "", required: true},
      notBlockedTaskIds: {
        type: Array,
        default() {
          return {}
        }
      }
    },
    data() {
      return {
        currentTaskId: this.taskId,
        otherSolutionView: this.$route.query.otherSolutionView || 'new',
        isNotBlockedTaskId: true,
      }
    },
    mounted() {
      this.setTask(this.taskId);
    },
    computed: {
      ...mapState([
        'isAuthenticated',
      ])
    },
    watch: {
      'taskId': function () {
        this.$nextTick(() => {
          this.setTask(this.taskId);
        });
      },
    },
    methods: {
      setTask: function (taskId) {
        this.currentTaskId = taskId;
        this.isNotBlockedTaskId = this.notBlockedTaskIds.includes(this.currentTaskId);
        this.$emit('newCurrentTaskId', taskId);
      },
      setTaskIdWithIndex(index_in_list) {
        let task = this.challengeData.tasks[index_in_list];
        this.setTask(task.task_id);
      },
      setOtherSolutionView(otherSolutionView){
        if (!this.isNotBlockedTaskId) {
          return;
        }
        this.otherSolutionView = otherSolutionView;
      },
    }
  }
</script>

<style scoped>
  .nav-stages li:hover {
    cursor: pointer;
  }

  .nav-stages li.active a {
    color: #061a2d;
    border: none;
    font-weight: bolder;
    background-color: transparent;
  }

  .nav-tabs.nav-stages > li.active > a:before {
    border-top: none;
  }

  .nav-tabs.nav-stages > li.active > a:hover {
    cursor: pointer;
    background-color: whitesmoke;
    border: none;
  }

  .stage-tabs {
    margin-left: 1.5rem;
  }

  .flex {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .panel {
    margin-bottom: 0;
  }

  .icon {
    margin-right: .5rem;
    font-size: 1.5rem;
  }
  
  @media (max-width: 836px) {
    .nav-tabs > li > a {
      padding: 1rem;
    }
  }

  @media (max-width: 606px) {
    .nav-tabs > li {
      margin-bottom: 0;
    }
  }


</style>